import { type Plugin } from "@nuxt/types";

import BrazeService from "@/utils/services/BrazeService";

declare module "@nuxt/types" {
  interface Context {
    $braze?: BrazeService;
  }
}

declare module "vue/types/vue" {
  interface Vue {
    $braze?: BrazeService;
  }
}

const plugin: Plugin = (context, inject) => {
  const braze = new BrazeService(context);

  // Injections prefix properties with a $
  inject("braze", braze);
  context.$braze = braze;
};

export default plugin;
